import React from "react";
import { InclusionCard } from "./InclusionCard";

export const ByCategoryTab = ({
  inclusions,
  onOpenAddItemModal,
  onEditBoq,
  onDeleteBoq,
  onDeleteInclusion,
  onBudgetUpdated,
  projectId,
  defaultExpanded = false,
  showCostFields = true,
  viewOnly = false,
  isDisable = false,
  inlineEditingBoqId,
  inlineEditingBoqInclusion,
  onSaveInlineEditBoq,
  onCancelInlineEditBoq,
  inlineEditSaving,
  isMobile = false,
  isTablet = false,
  project,
  isSiteVisit = false,
  isSiteEstimatesRoute = false,
  isReview = false,
  isExpanded = false,
}) => {
  if (!inclusions || inclusions.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 256,
        }}
      >
        <div style={{ fontSize: 16, color: "#4b5563" }}>
          No inclusions found for this project
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {inclusions.map((inclusion) => (
        <InclusionCard
          key={inclusion.name}
          inclusion={inclusion}
          projectId={projectId}
          project={project}
          onOpenAddItemModal={onOpenAddItemModal}
          onEditBoq={onEditBoq}
          onDeleteBoq={onDeleteBoq}
          onDeleteInclusion={onDeleteInclusion}
          onBudgetUpdated={onBudgetUpdated}
          disabled={false}
          defaultExpanded={defaultExpanded}
          showCostFields={showCostFields}
          viewOnly={viewOnly}
          isDisable={isDisable}
          inlineEditingBoqId={inlineEditingBoqId}
          inlineEditingBoqInclusion={inlineEditingBoqInclusion}
          onSaveInlineEditBoq={onSaveInlineEditBoq}
          onCancelInlineEditBoq={onCancelInlineEditBoq}
          inlineEditSaving={inlineEditSaving}
          isMobile={isMobile}
          isTablet={isTablet}
          isSiteVisit={isSiteVisit}
          isSiteEstimatesRoute={isSiteEstimatesRoute}
          isReview={isReview}
          isExpanded={isExpanded}
        />
      ))}
    </div>
  );
};

export default ByCategoryTab;
